var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-edit',{on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"userData":_vm.userData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }